// import Footer from "../pages/Footer"; // или откъдето е текущият футър
import HeaderRedesign from "../pages/HeaderRedesign"; // ще създадем и него

export default function RedesignLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <HeaderRedesign />
      <main className="flex-grow">{children}</main>
      {/* <Footer /> */}
    </div>
  );
}
